import "../../components/atoms/buttons/button.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "./../login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../components/atoms/buttons/Button";
import Titulo from "../../components/atoms/titles/Titulo";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import ButtonVolver from "../../components/atoms/buttons/ButtonVolver";
import AcumuladoresTabActosAdmin from "../../components/molecules/tabs/acumuladoresTab/AcumuladoresTabActosAdmin";
import {
  getDatoBorradores,
  getDatoPresentada,
} from "../../components/services/DatoPersonalService";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";

const CambioCuentaCorriente = () => {
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState({
    borradores: false,
    solicitudes: false,
  });
  const navigate = useNavigate();
  const [borradores, setBorradores] = useState([""]);
  const [actosPresentados, setActosPresentados] = useState([]);
  const [errorBorrador, setErrorBorrador] = useState(false);
  const [errorPresentada, setErrorresentada] = useState(false);
  const { state } = useLocation();
  const [accesoPDF] = useState(state?.accesoPDF);

  useEffect(() => {
    setLoading(true);

    getDatoBorradores("s1").then((data) => {
      
      if (data !== undefined) {
        setBorradores(data);
        setLoadingData((prevState) => ({
          ...prevState,
          borradores: true,
        }));
      } else {
        setErrorBorrador(true);
      }
    });
    getDatoPresentada("s1").then((data) => {
      
      if (data !== undefined || !data.toString().startsWith("Error:")) {
        setActosPresentados(data);
        setLoadingData((prevState) => ({
          ...prevState,
          solicitudes: true,
        }));
      } else {
        setErrorresentada(true);
      }
    });
  }, []);

  const handleActualizarPresentada = () => {
    getDatoPresentada("s1").then((data) => {
      
      if (data !== undefined || !data.toString().startsWith("Error:")) {
        setActosPresentados(data);
        setLoadingData((prevState) => ({
          ...prevState,
          solicitudes: true,
        }));
      } else {
        setErrorresentada(true);
      }
    });
  }

  function CambioCuentaCorriente() {
    return (
      <>
        <div className="vh-100" role="main" data-landmark-index="4">
          <Header></Header>
          <div className="contanier d-flex flex-column align-items-center my-lg-5 my-md-5 my-sm-3 py-2">
            {loading ? (
              <>
                <div className="container d-flex justify-content-start">
                  <Titulo
                    tipo={"tituloModal "}
                    titulo={"Cambio en Cuenta Corriente"}
                  />
                </div>
                <p className="mt-2">Acto S1 - Cambio en Cuenta Corriente</p>

                {/* Borradores y Actos presentados */}
                <div className="row d-flex justify-content-center tablaRecNivel">
                  <div className="col-12 card pb-5">
                    {loadingData.borradores && loadingData.solicitudes ? (
                      <AcumuladoresTabActosAdmin
                        borradores={borradores}
                        setBorradores={setBorradores}
                        actosPresentados={actosPresentados}
                        setActosPresentados={setActosPresentados}
                        handleActualizarPresentada={handleActualizarPresentada}
                        loading={loadingData}
                        errorBorrador={errorBorrador}
                        errorPresentada={errorPresentada}
                        accesoPDF={accesoPDF}
                      />
                    ) : (
                      <SpinnerCircle></SpinnerCircle>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <ButtonVolver
                    destino={"home"}
                    clases="col-3 mt-3 mb-3"
                  ></ButtonVolver>
                  {borradores.length < 10 ? (
                    <Button
                      id="btnNuevaSolicitudNC"
                      clases="btn-card rounded seleccion-mes mt-3 mb-3"
                      nombre={
                        <>
                          <i className="fa-solid fa-file-circle-plus"></i> Nuevo
                          Borrador
                        </>
                      }
                      tipo="button"
                      funcion={() => navigate("/borradorActos")}
                    />
                  ) : null}
                </div>
              </>
            ) : (
              <></>
            )}
            <br />
          </div>
          <Footer></Footer>
        </div>
      </>
    );
  }

  return <>{CambioCuentaCorriente()}</>;
};

export default memo(CambioCuentaCorriente);
